import bem from 'utils/bem';

export const block = bem('plan-decision-modal');
